import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { getUserSettings, updateUserSettings } from "../api/api"; // API calls

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [user, setUser] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUserSettings();
        setUser(userData);
        setName(userData.name);
        setEmail(userData.email);
      } catch (error) {
        console.error("Error fetching user settings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleSave = async () => {
    if (!user) return;

    setSaving(true);
    try {
      await updateUserSettings({ name, newPassword });

      alert("Settings updated successfully!");
      setNewPassword(""); // Clear password field after updating
    } catch (error) {
      console.error("Error updating settings:", error);
      alert("Failed to update settings. Try again.");
    }
    setSaving(false);
  };

  if (loading) {
    return (
      <Container sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Card>
        <CardContent>
          <Typography variant="h5">User Settings</Typography>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Email (Cannot be changed)"
            value={email}
            disabled
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="New Password (Optional)"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Settings;
